export default __webpack_public_path__ + "static/main6-480-49a6de5c5b47b435b66695915ee02c21.png";